import React, { FC, ReactElement } from 'react';
import { LinearProgress } from '@material-ui/core';
import { WarehouseState } from '../../reducers/typings';
import ProductCategory from '../ProductCategory';
import { ProductAvailabilityChange } from '../../services/warehouse';
import { StyleProps, useStyles } from './styles';

export interface Props extends StyleProps {
  currentMenu: WarehouseState['currentMenu'];
  loading: WarehouseState['isFetching'];
  search: string;
  productAvailabilityChanges: ProductAvailabilityChange[];
  changeProductOrderAvailability(product_id: number): void;
}

const ProductBrowser: FC<Props> = ({
  loading,
  expanded,
  search,
  productAvailabilityChanges,
  changeProductOrderAvailability,
  currentMenu,
}: Props): ReactElement => {
  const classes = useStyles({ expanded });

  return (
    <div className={loading ? classes.loadingContainer : classes.categoryContainer}>
      {loading && <LinearProgress className={classes.linearProgress} />}
      {!loading &&
        currentMenu &&
        Array.isArray(currentMenu.categories) &&
        currentMenu.categories
          .filter(
            (category: any) => Array.isArray(category.products) && category.products.length > 0,
          )
          .map(
            (category: any, index: number): ReactElement => {
              return (
                <ProductCategory
                  key={category.name}
                  name={category.name}
                  index={index}
                  products={category.products}
                  search={search}
                  productAvailabilityChanges={productAvailabilityChanges}
                  changeProductOrderAvailability={changeProductOrderAvailability}
                />
              );
            },
          )}
    </div>
  );
};

export default ProductBrowser;
